import React, {useState} from "react";
import {useParams} from "react-router-dom";
import Typography from "@mui/material/Typography";

export default function Maps() {
    const {eventId} = useParams();
    const [hasMap, setHasMap] = useState<boolean | null>(null);

    return <React.Fragment>
        <img
            alt="site map"
            src={`/api/events/${eventId}/site/map`}
            width="100%"
            style={{display: hasMap === false ? 'none' : 'block'}}
            onLoad={() => setHasMap(true)}
            onError={() => setHasMap(false)}
        />
        {hasMap === false && <Typography align="center" sx={{mt: 4}}>No site map available for this event.</Typography>}
    </React.Fragment>
}
